import { useEffect, useRef } from "react";
import { modalManager } from "../helpers/ModalManager";

export const useModalManager = (open, onClose) => {
  const modalIdRef = useRef(null);
  const onCloseRef = useRef(onClose);

  useEffect(() => {
    onCloseRef.current = onClose;
  }, [onClose]);

  useEffect(() => {
    modalManager.init();

    return () => {
      if (!modalManager.count()) {
        modalManager.destroy();
      }
    };
  }, []);

  useEffect(() => {
    // Открытие
    if (open && !modalIdRef.current) {
      if (modalManager.closingFromHistory) return;

      modalIdRef.current = modalManager.addModal((reason) => {
        modalIdRef.current = null;

        onCloseRef.current?.(
          {},
          reason === "back" ? "backButton" : "close"
        );
      });
      return;
    }

    // Закрытие через UI
    if (!open && modalIdRef.current) {
      modalManager.closeModal(modalIdRef.current);
      modalIdRef.current = null;
    }
  }, [open, onClose]);
};
